/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import {
  Card,
  Typography,
  Descriptions,
  Empty,
  Divider,
  Button,
  Modal,
  Form,
  message,
  //Row,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import ClientOrgEdit from "./CustomerDetailEdit/ClientOrgEdit";
import { customerOnboardingAPI } from "../api/LeadApi";
const { Title } = Typography;
import ClientBusinessEdit from "./CustomerDetailEdit/ClientBusinessEdit";

/**
 * Reusable DetailsViewer Component
 * @param {string} title - Section title
 * @param {Object | Array} data - Data to display
 */
const DetailsViewer = ({
  title,
  data,
  isEdit,
  getData,
  apiUrl,
  menukey,
  fetchData = () => {},
  customerId,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [form] = Form.useForm();

  useEffect(() => {
    setInitialValues({ ...data, street: data?.street });
  }, [data]);

  const getChangedValues = (initial, current) => {
    return Object.keys(current).reduce((acc, key) => {
      if (initial[key] !== current[key]) {
        acc[key] = current[key];
      }
      return acc;
    }, {});
  };

  const onSave = async (data) => {
    let payload = {};
    if (menukey === "organisation") {
      const changedValues = getChangedValues(initialValues, data);

      if (Object.keys(changedValues).length === 0) {
        message.info("No changes detected.");

        return;
      }
      const kycDocs = [];

      if (changedValues?.gstNo) {
        kycDocs.push({
          idType: "GST",
          idNumber: data?.gstNo,
          isVerified: true,
        });
      }
      if (changedValues?.aadharNo) {
        kycDocs.push({
          idType: "AADHAR",
          idNumber: data?.aadharNo,
          isVerified: false,
        });
      }
      if (changedValues?.tanNo) {
        kycDocs.push({
          idType: "TAN",
          idNumber: data?.tanNo,
          isVerified: false,
        });
      }

      payload = {
        customer: {
          kycDocuments: kycDocs?.length > 0 ? kycDocs : undefined,

          addresses:
            changedValues?.pincode || changedValues?.street
              ? [
                  {
                    type: "DEFAULT",
                    pincode: data?.pincode,
                    street: data?.street,
                    area: data?.area,
                  },
                ]
              : undefined,
          contactNumbers: changedValues?.mobileNumber
            ? [
                {
                  type: "DEFAULT",
                  number: data?.mobileNumber,
                },
              ]
            : undefined,
          emails: changedValues?.emailId
            ? [
                {
                  type: "DEFAULT",
                  email: data?.emailId,
                },
              ]
            : undefined,
        },
      };
    } else if (menukey === "business") {
      payload = {
        customer: {
          addresses: [
            {
              type: "BILLING",
              pincode: data?.pincode,
              street: data?.street,
            },
          ],
        },
      };
    }

    const response = await customerOnboardingAPI.putMaster(
      customerId,
      payload,
      apiUrl
    );
    if (response?.status) {
      message.success("Data updated successfully");
      fetchData();
      setIsEditing(false);
    } else {
      message.error(
        response?.response?.data?.message || "Internal Server Error"
      );
    }
  };

  if (!data || Object.keys(data).length === 0)
    return (
      <div className="center">
        <Empty />
      </div>
    );

  const formatLabel = (label) =>
    label
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase())
      .trim();

  //console.log(getData);

  return (
    <>
      <Card
        bordered={false}
        style={{
          borderRadius: 8,
          boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
          marginBottom: 16,
          padding: 8,
        }}
      >
        <div className="space-between">
          <Title level={4} style={{ textAlign: "center", fontSize: "15px" }}>
            {title}
          </Title>
          {isEdit && (
            <Button
              icon={<EditOutlined />}
              onClick={() => {
                setIsEditing(true);

                form.setFieldsValue(data);
                let address = {};
                if (menukey === "organisation") {
                  address = getData?.addresses?.find(
                    (e) => e?.type === "COLLECTION"
                  );
                } else if (menukey === "business") {
                  address = getData?.addresses?.find(
                    (e) => e?.type === "BILLING"
                  );
                }

                form.setFieldsValue({
                  street: address?.street,
                  pincode: address?.pincode,
                });
              }}
            >
              Edit
            </Button>
          )}
        </div>
        <Divider />
        {Array.isArray(data) ? (
          <Descriptions column={1}>
            {data?.map((data, index) => (
              <Descriptions.Item
                key={index}
                label={`${index + 1}: ${data?.label || ""}`}
              >
                {data?.type === "link" ? (
                  <a onClick={() => window.open(data?.linkUrl)}>
                    {data?.value || "N/A"}
                  </a>
                ) : (
                  data?.value || "N/A"
                )}
              </Descriptions.Item>
            ))}
          </Descriptions>
        ) : (
          <Descriptions column={2} size="small" bordered className="label-50">
            {Object?.entries(data)?.map(([key, value]) => (
              <Descriptions.Item key={key} label={formatLabel(key)}>
                {value || "N/A"}
              </Descriptions.Item>
            ))}
          </Descriptions>
        )}
      </Card>
      {isEditing && isEdit && (
        <Modal
          open={isEditing}
          onCancel={() => setIsEditing(false)}
          title={title}
          footer={[
            <Button key="cancel" onClick={() => setIsEditing(false)}>
              Cancel
            </Button>,
            <Button
              key="save"
              type="primary"
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    onSave(values);
                  })
                  .catch((info) => {
                    console.log("Validate Failed:", info);
                  });
              }}
            >
              Save
            </Button>,
          ]}
        >
          <Form
            form={form}
            onFinish={onSave}
            className="global-form"
            layout="vertical"
          >
            {menukey === "organisation" ? (
              <ClientOrgEdit getData={getData} />
            ) : (
              <ClientBusinessEdit getData={getData} />
            )}
          </Form>
        </Modal>
      )}
    </>
  );
};

export default DetailsViewer;
